import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=79e496cd&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e496cd')) {
      api.createRecord('79e496cd', component.options)
    } else {
      api.reload('79e496cd', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=79e496cd&", function () {
      api.rerender('79e496cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4kyjKXULHXasP/JS/comp/childrenage.vue"
export default component.exports